// extracted by mini-css-extract-plugin
export default {"card":"UnlockedFeatureCard_card__9qyyM","icon":"UnlockedFeatureCard_icon__8SBAI","title":"UnlockedFeatureCard_title__Fl78V","description":"UnlockedFeatureCard_description__b11UC"};